"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResults = getResults;
exports.questions = void 0;

var _utils = require("./utils");

var batteryId = _utils.screeners.ROI_HPQ_3_POINTSLIDE;
var labels = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
var baseProps = {
  batteryId: batteryId,
  aggregated: true,
  extraText: "",
  type: "pointslider",
  options: labels,
  specific: true
};
var roiQuestions = [// ROI measures - 1 questions
{
  prompt: "On a scale from 0 to 10, where 0 is the worst job performance " + "anyone could have at your job and 10 is the best performance anyone " + "could have, how would you rate your overall job performance on the " + "days you worked in the past 4 weeks?"
}];
var questions = (0, _utils.wrapBattery)(roiQuestions, baseProps);
exports.questions = questions;

function getResults(answers) {
  var humanReadable = {};
  questions.forEach(function (q, i) {
    humanReadable[q.prompt] = answers[i];
  });
  return {
    roiPerfomance: answers[0],
    humanReadable: humanReadable
  };
}